"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ON_DETAILS_SET = exports.ON_ITEM_CHANGED = exports.ON_ITEM_REMOVED = exports.ON_CART_CLEARED = exports.ON_CART_FETCHED = exports.ON_ITEM_UPDATED = exports.ON_ITEM_ADDED = exports.ON_CART_PENDING = exports.ON_CART_FINISHED = void 0;
exports.ON_CART_FINISHED = 'onCartFinished';
exports.ON_CART_PENDING = 'onCartPending';
exports.ON_ITEM_ADDED = 'onCartAdded';
exports.ON_ITEM_UPDATED = 'onCartUpdated';
exports.ON_CART_FETCHED = 'onCartFetched';
exports.ON_CART_CLEARED = 'onCartCleared';
exports.ON_ITEM_REMOVED = 'onItemRemoved';
exports.ON_ITEM_CHANGED = 'onItemChanged';
exports.ON_DETAILS_SET = 'onDetailsSet';
//# sourceMappingURL=events.js.map